import { EnvironmentService } from './../core/enviroment/environment.service';
import {
  GetMembers,
  Member,
  OperationMarkets,
  Pagination,
  Sort,
  SORT_ENUM,
  TmItem,
  TmSortProperties,
  TmTag
} from './../core/models/team-management.model';
import { TeamManagementService } from './service/team-management.service';
import { OPTIONS_TM_ENUM } from './../core/constants/team-management-const';
import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-team-management',
  templateUrl: './team-management.component.html',
  styleUrls: ['./team-management.component.scss']
})
export class TeamManagementComponent implements OnInit {

  public searchForm: FormGroup;
  public autocomp: boolean;
  public autocompIdx: number;
  public autocompleteTeamMembers: any[];
  public editWorkSchedule = false;
  public editingScheduleMembers: TmItem[] = [];
  public usersToConfigure = [];
  public openConfigUsers = false;
  public redirectSeeProfile = false;
  public redirectSeeFacs = false;
  public searchingTeam = false;
  public pagination: Pagination;
  public sortData: Sort;
  public tags: TmTag[] = [];
  public inputSearchValue = '';
  public sortedColumn: number;
  public listHeaders = [
    {
      id: 1,
      nameClass: 'name',
      data: 'input',
      sort: true
    },
    {
      id: 2,
      nameClass: 'product',
      data: 'Apelido (Super.)',
      sort: true
    },
    {
      id: 3,
      nameClass: 'contact',
      data: 'Contato',
      sort: false
    },
    {
      id: 4,
      nameClass: 'market',
      data: 'Mercado',
      sort: true
    },
    {
      id: 5,
      nameClass: 'creci-expiration',
      data: 'Validade do Creci',
      sort: true
    },
  ];
  public listBinding = [];
  public isOpenMenu = false;

  public selectedTeamMembers = [];

  @HostListener('document:click', ['$event'])
  onClick(ev: Event) {
    if (this.isOpenMenu) {
      if (!this.eRef.nativeElement.contains(ev.target)) {
        this.isOpenMenu = false;
      }
    }
  }

  constructor(
    private formBuilder: FormBuilder,
    private eRef: ElementRef,
    private router: Router,
    private service: TeamManagementService,
    private environmentService: EnvironmentService
  ) { }

  validateMarket(operationMarkets: OperationMarkets[], sale: boolean, rent: boolean) {
    const MarketType = {
      PRIMARY: 'Primário',
      SECONDARY: 'Secundário'
    }
    let market = operationMarkets.map(el => MarketType[el.operationMarketType]).join(' e ');

    const types = [{ value: sale, label: 'Venda' }, { value: rent, label: 'Locação' }];
    market += types.map(el => {
      if (el.value) { return el.label; }
    }).filter(Boolean).join('/');

    return market;
  }

  ngOnInit(): void {
    this.initForm();
    this.useMock();
    const data: GetMembers = {
      page_number: 1,
      page_items: 20,
      sort: 'agent.nickname',
      sort_order: SORT_ENUM.ASC,
      search_values: ''
    };
    this.listTeam(data);
  }

  isCreciValid(dateStr: string) {
    const { year, month, day } = dateStr.match(/(?<year>\d{4})-(?<month>\d{2})-(?<day>\d{2})/).groups;
    if (!year || !month || !day) { return false; }
    const creci = new Date(`${dateStr} 00:00:00`);
    const today = new Date();
    creci.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return today.getTime() <= creci.getTime();
  }

  formatDateString(date: string) {
    return date.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3-$2-$1');
  }

  processTeamList = validateMarket => (member: Member) => {
    const operationMarkets = Array.isArray(member.operation_markets) ? member.operation_markets : [member.operation_markets];
    return {
      ...member,
      userLabel: `${this.capitalizeFirstLetter(member.nickname)} (${this.capitalizeFirstLetter(member.leader_nickname)})`,
      market: validateMarket(operationMarkets, member.sale, member.rent),
      creci_status: this.isCreciValid(member.creci_validity),
      creci_validity: this.formatDateString(member.creci_validity)
    };
  }

  capitalizeFirstLetter(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }

  buildSortData(sort: Sort): Sort {
    let sortData: Sort = this.sortData;
    if (sort?.sort && !sort?.sort_order) {
      sortData.sort = null;
      sortData.sort_order = null;
      this.sortData = sortData;
    }
    if (sort?.sort_order) {
      sortData = {
        sort: TmSortProperties[sort.sort],
        sort_order: sort.sort_order
      };
      this.sortData = sortData;
    }
    return sortData;
  }

  listTeam(data: GetMembers): void {
    if (this.searchingTeam) { return; }
    this.searchingTeam = true;
    const observer = this.service.getTeam(data).subscribe(response => {
      this.pagination = response.next_request;
      if (response.payload) {
        const buildItem = this.processTeamList(this.validateMarket);
        this.listBinding.push(...response.payload.map(buildItem));
      }
      this.searchingTeam = false;
      observer.unsubscribe();
    });
  }

  listTeamPaginated(element): void {
    if (!this.pagination || !this.pagination.page_number) { return; }
    element.scroll(0, element.scrollTop - element.scrollTop * .03);
    const data: GetMembers = {
      page_number: this.pagination?.page_number,
      page_items: this.pagination?.page_items,
      sort: this.sortData?.sort,
      sort_order: this.sortData?.sort_order,
      search_values: this.tags.map(el => el.id).join(';')
    };
    this.listTeam(data);
  }

  listTeamSorted(sort?: Sort): void {
    this.listBinding = [];
    this.sortedColumn = Number(sort.sort);
    const sortData = this.buildSortData(sort);
    const data: GetMembers = {
      page_number: 1,
      page_items: 20,
      sort: sortData?.sort || 'agent.nickname',
      sort_order: sortData?.sort_order || SORT_ENUM.ASC,
      search_values: this.tags.map(el => el.id).join(';')
    };
    this.listTeam(data);
  }

  useMock(): void {
    this.autocompleteTeamMembers = [
      { id: 'mock', name: 'mock' }
    ];
  }

  public initForm(): void {
    this.searchForm = this.formBuilder.group({
      search: [null]
    });
  }

  public autocompleteSearchTeamMember(searchTxt: string): void {
    this.inputSearchValue = searchTxt;
    if (searchTxt.length < 3) {
      this.autocomp = false;
      return;
    }
    const observer = this.service.autocomplete({ max_results: 10, search_value: searchTxt }).subscribe(response => {
      this.autocompleteTeamMembers = response.payload.map(el => ({
        id: el.description,
        name: el.label,
        label: el.label,
        type: el.type,
        description: el.label
      }));
      this.autocomp = true;
      observer.unsubscribe();
    });
  }

  public searchTeamMember(selected: { value: string, index: number }): void {
    const tags: TmTag[] = [...this.tags];
    const description = this.autocompleteTeamMembers[selected.index].id;
    if (!tags.find(el => el.id.includes(description))) {
      tags.push({ value: selected.value.trim(), id: description });
    }
    this.tags = tags;
    this.inputSearchValue = '';
    const data: GetMembers = {
      page_number: 1,
      page_items: 20,
      sort: this.sortData?.sort,
      sort_order: this.sortData?.sort_order,
      search_values: tags.map(el => el.id).join(';')
    };
    this.listBinding = [];
    this.listTeam(data);
    this.autocomp = false;
    this.autocompIdx = -1;
  }

  public editMultipleUsers(): void {
    this.usersToConfigure = Array.from(this.selectedTeamMembers);
    this.openConfigUsers = !this.openConfigUsers;
  }

  public editMultipleWorkSchedule(): void {
    this.isOpenMenu = false;
    this.editingScheduleMembers = Array.from(this.selectedTeamMembers);
    this.editWorkSchedule = true;
  }

  configUser(data: TmItem) {
    this.usersToConfigure = [{ id: data.id, name: data.name, userLabel: data.userLabel, nickname: data.nickname }];
    this.openConfigUsers = !this.openConfigUsers;
  }

  editScale(data: TmItem) {
    this.editingScheduleMembers = [{
      id: data.id,
      user_id: data.user_id,
      userLabel: data.userLabel,
      name: data.name,
      nickname: data.nickname
    }];
    this.editWorkSchedule = true;
  }

  seeProfile(data: TmItem) {
    this.router.navigate([`perfil/${data.name}/perfil`]);
    this.redirectSeeProfile = true;
  }

  seeFacs(data: TmItem) {
    this.router.navigate([`/facs`], { queryParams: { user_type: data.type, user_id: data.id, user_nickname: data.nickname, user_name: data.name } });
    this.redirectSeeFacs = true;
  }

  sendOptions(data: TmItem) {
    switch (data.option) {
      case OPTIONS_TM_ENUM.EDIT_SCALE:
        this.editScale(data);
        break;
      case OPTIONS_TM_ENUM.CONFIG_USER:
        this.configUser(data);
        break;
      case OPTIONS_TM_ENUM.SEE_PROFILE:
        this.seeProfile(data);
        break;
      case OPTIONS_TM_ENUM.SEE_FACS:
        this.seeFacs(data);
        break;
    }
  }

  sendItemSelections(data: TmItem) {
    this.removingAndAdd(data, this.selectedTeamMembers);
  }

  public sendAllSelections(data: TmItem) {
    if (data.select) {
      this.selectedTeamMembers.push(data);
    } else {
      this.selectedTeamMembers = [];
    }
  }

  public removingAndAdd(data: TmItem, list: TmItem[]): void {
    const index = list.findIndex(el => el.user_id === data.user_id);
    if (data.select && index === -1) {
      list.push(data);
    }
    if (!data.select && index > -1) {
      list.splice(index, 1);
    }
  }

  public removeTag(index: number): void {
    const tags: TmTag[] = [...this.tags];
    this.listBinding = [];
    tags.splice(index, 1);
    this.tags = tags;
    const data: GetMembers = {
      page_number: 1,
      page_items: 20,
      sort: this.sortData?.sort,
      sort_order: this.sortData?.sort_order,
      search_values: tags.map(el => el.id).join(';')
    };
    this.listTeam(data);
  }

}
